import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "./components/accordion.js";
import "./components/sidebarCta.js";

import "../styles/evotis_3.css";

handleFloatingPromise(initExpertSite());
